import React from 'react'
import PropTypes from 'prop-types'

import ContentLoader from 'components/loaders/ContentLoader/ContentLoader'


const ContentWithLoader = ({ className, fullHeight, children, isFetching }) => (
  isFetching ? (
    <ContentLoader className={className} fullHeight={fullHeight} />
  ) : children
)

ContentWithLoader.propTypes = {
  children: PropTypes.node,
  isFetching: PropTypes.bool,
  fullHeight: PropTypes.bool,
  className: PropTypes.string,
}

ContentWithLoader.defaultProps = {
  children: null,
}


export default ContentWithLoader
